import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { RestApiService } from './rest-api.service';

@Injectable({
  providedIn: 'root'
})
export class CommonBindingDataService {
  private translateService = inject(TranslateService);
  private restApiService = inject(RestApiService);

  showEditProfile = new Subject<any>();

  private _profileShowHide = new Subject<boolean>();
  private _userProfileDetails = new BehaviorSubject<boolean>(false);
  private _isHideMobileTabNav = new BehaviorSubject<boolean>(false);
  public $isHideMobileTabNav = this._isHideMobileTabNav.asObservable();

  getLabel(string: any) {
    let select;
    this.translateService.get(string).subscribe(translatedValue => {
      select = translatedValue;
    });
    return select;
  }

  getBookingDetails(bookingType: any): Observable<any> {
    return this.restApiService.get('get-passenger-details', `/secure/booking/user/list/PASSENGER?offset=0&type=${bookingType ? bookingType : ''}`);
  }
  getStayLocation(): Observable<any> {
    return this.restApiService.get('get-stay-location', '/secure/stay-location');
  }
  getPickupLocaions(): Observable<any> {
    return this.restApiService.get('get-pickup-location', `/secure/location/search-places?searchText=&addressType=SOURCE&userType=PASSENGER`, 'page-center');
  }
  getStayLocaions(): Observable<any> {
    return this.restApiService.get('get-stay-location', `/secure/locations?projection=grid&activated=true&locationCategoryId=locCatId00003&offset=0&limit=9999`, 'page-center');
  }
  getDropoffLocaions(): Observable<any> {
    return this.restApiService.get('get-dropoff-location', `/secure/location/search-places?searchText=&addressType=DESTINATION&userType=PASSENGER`, 'page-center');
  }
  getPrebookingDetails(): Observable<any> {
    return this.restApiService.get('get-prebooking-details', `/secure/booking/pre-booking/data`, 'page-center');
  }
  getUpcomingBookingDetails(): Observable<any> {
    return this.restApiService.get('get-upcoming-details', `/secure/bookings/active-trips`, 'page-center');
  }
  getPrivilegeBookingDetails(): Observable<any> {
    return this.restApiService.get('get-privillage-booking-details', `/secure/privilege-settings/passenger-type-permissions`, 'page-center');
  }
  getParticularBookingDetails(bookingId: any): Observable<any> {
    return this.restApiService.get('get-particular-booking-details', `/secure/tour-receipt/${bookingId}`, 'page-center');
  }
  getFareEstimate(ServiceTypeId: any, data: any): Observable<any> {
    return this.restApiService.post('fare-estimate', `/secure/booking/${ServiceTypeId}/fare-estimation`, data, 'page-center');
  }
  createBooking(ServiceTypeId: any, data: any): Observable<any> {
    return this.restApiService.post('create-booking', `/secure/booking/${ServiceTypeId}`, data, 'page-center');
  }
  addStayLocation(data: any): Observable<any> {
    return this.restApiService.post('add-stay-location', `/secure/user-stay-location`, data, 'page-center');
  }
  getDriverPosition(tripId: any): Observable<any> {
    return this.restApiService.get('get-current-driver-position', `/secure/tour-driver/current-location/${tripId}`, 'page-center');
  }
  cancelBooking(data: any): Observable<any> {
    return this.restApiService.get('cancel-booking', `/secure/booking-cancel/${data.tourID}/passenger?cnftoprced=${data.cnftoprced}`, 'page-center');
  }
  scanBarcode(data: any): Observable<any> {
    return this.restApiService.post('scan-barcode', `/signin/passenger`, data, 'page-center');
  }
  ssoLogin(data: any): Observable<any> {
    return this.restApiService.post('sso-login', `/openid/user-signin`, data, 'page-center');
  }
  signInApi(data: any): Observable<any> {
    return this.restApiService.post('sign-in', `/users/verify-otp`, data, 'page-center');
  }

  getNotificationDetails(): Observable<any> {
    return this.restApiService.get('get-notification-details', `/secure/users/notification`, 'page-center');
  }

  getProfileDetails(): Observable<any> {
    return this.restApiService.get('get-profile-details', `/secure/user-profile/users`, 'page-center');
  }

  getReverseGoeLocation(data: any): Observable<any> {
    return this.restApiService.get('get-profile-details', `/secure/google-map/reverse-geocode?latLng=${data.lat},${data.lng}`, 'page-center');
  }

  editProfileDetails(data: any): Observable<any> {
    return this.restApiService.put('edit-user-details', `/secure/user-profile/users`, data, 'page-center');
  }

  updateSmsandNotification(data: any, userId: any): Observable<any> {
    return this.restApiService.put('update-sms-notification', `/secure/user-profile/email-sms-status/${userId}`, data, 'page-center');
  }

  getTimeSlots(data: any): Observable<any> {
    return this.restApiService.post('time-slots', `/secure/tour-pickup/time-slots`, data, 'page-center');
  }

  profileShowHide(showHideValue: boolean) {
    this._profileShowHide.next(showHideValue);
  }

  get profileShowHideEvent(): Subject<any> {
    return this._profileShowHide;
  }

  getUserProfileDetails(user: boolean) {
    this._userProfileDetails.next(user)
  }

  get userDataEvent(): Subject<any> {
    return this._userProfileDetails;
  }

  getRefreshIntevalTime(): Observable<any> {
    return this.restApiService.get('passenger-metadata', `/passenger/metadata`, 'page-center');
  }
  setIsHideMobileTabNav(isHide: boolean) {
    this._isHideMobileTabNav.next(isHide);
  }
  getIsHideMobileTabNav(): Observable<boolean> {
    return this._isHideMobileTabNav.asObservable();
  }
}